import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'

import {VSkeletonLoader} from 'vuetify/labs/VSkeletonLoader'
import Avatar from "vue-boring-avatars"

import 'vuetify/styles'

const minimal = {
  colors: {
    background: '#FFFFFF',
    surface: '#FFFFFF',
    primary: '#777',
    'primary-darken-1': '#3700B3',
    secondary: '#795548',
    'secondary-darken-1': '#018786',
    error: '#B00020',
    info: '#2196F3',
    success: '#4CAF50',
    warning: '#FB8C00',
  },
}

export default {
  install: (app: App) => {
    const vuetify = createVuetify({
      components: {
        ...components,
        VSkeletonLoader,
        Avatar,
      },
      directives,
      theme: {
        defaultTheme: 'minimal',
        themes: {
          minimal,
        },
      },
      display: {
        mobileBreakpoint: 'sm',
        thresholds: {
          xs: 0,
          sm: 340,
          md: 700,
          lg: 900,
          xl: 1080,
        },
      },
    })

    app.use(vuetify)
  }
}